export default "images/turing-logo.png";